import { lazy } from 'react'
import { LayoutDashboard, BarChart3 } from 'lucide-react'
import type { FeatureRoute, NavItem } from '@/features/types'

const Dashboard = lazy(() => import('@/features/dashboard/pages/Dashboard').then((m) => ({ default: m.Dashboard })))
const Reports = lazy(() => import('@/features/dashboard/pages/Reports').then((m) => ({ default: m.Reports })))
const Digest = lazy(() => import('@/features/dashboard/pages/Digest').then((m) => ({ default: m.Digest })))
const GoalPlanner = lazy(() => import('@/features/dashboard/pages/GoalPlanner').then((m) => ({ default: m.GoalPlanner })))

export const dashboardRoutes: FeatureRoute[] = [
  { index: true, element: <Dashboard /> },
  { path: 'reports', element: <Reports /> },
  { path: 'digest', element: <Digest /> },
  { path: 'planner', element: <GoalPlanner /> },
]

export const dashboardNav: NavItem[] = [
  { to: '/', label: 'Dashboard', icon: LayoutDashboard, section: 'Overview' },
  { to: '/reports', label: 'Reports', icon: BarChart3, section: 'Sales' },
]
